export default __webpack_public_path__ + "static/after-e79618dbcd8b01b873ef2047625f2200.png";